import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Faq = () => {
    const { t } = useLang();
    const [open, setOpen] = useState(0);
    const items = t("faq.items") || [];

    return (
        <div data-testid="faq-accordion" className="max-w-2xl mx-auto">
            {items.map((item, i) => (
                <div key={i} className="border-b border-stone-200">
                    <button
                        onClick={() => setOpen(open === i ? -1 : i)}
                        data-testid={`faq-item-${i}`}
                        className="w-full flex items-center justify-between gap-4 py-4 text-left"
                    >
                        <span className="text-sm sm:text-base font-semibold text-ink">{item.q}</span>
                        <ChevronDown
                            className={`h-4 w-4 text-bordeaux shrink-0 transition-transform duration-300 ${
                                open === i ? "rotate-180" : ""
                            }`}
                            strokeWidth={2}
                        />
                    </button>
                    <div
                        className={`grid transition-all duration-300 ease-out ${
                            open === i ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                        }`}
                    >
                        <div className="overflow-hidden">
                            <p className="pb-4 text-sm text-stone-600 leading-relaxed">{item.a}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
